const USER = {
  TYPES: {
    ADMIN: 'ADMIN',
    USER: 'USER',
    QUARENTINE: 'QUARENTINE',
  },
  EVENTS: {
    LOGIN_CHECKED: 'loginchecked',
  },
  FOLLOWED_USERS: 'Membros que sigo',
  NOT_FOUND_USER: 'Nenhum usuário encontrado',
};

export default USER;
